import availableFonts from '../../constants/AvailableFonts';

const slideParserUtils = {
    getRotation (transform) {

        if (transform == '' || transform.length < 1)
            return 0;

        const pattern = /[-|+]?[0-9]*\.?[0-9]+/;
        let rotation = Number(pattern.exec(transform)[0]);

        if (isNaN(rotation))
            return 0;

        if (rotation > 360)
            rotation = rotation - 360;

        return rotation;
    },

    dataToToughtPoints (path) {
        const points = [];
        const index = path.indexOf('Q');
        const moveStr = path.substr(1, index - 1);
        const lineStr = path.substr(index, path.length - index);
        let x;
        let y;
        let line;
        const moves = moveStr.split(',');
        let lines = lineStr.split('Q');

        lines = lines.splice(1, lines.length - 1);
        x = Number(moves[0]);
        y = Number(moves[1]);

        points.push({x, y});

        const length = lines.length;
        let i;

        for (i = 0; i < length; i++) {
            line = lines[i].split(',');
            x = Number(line[0]);
            y = Number(line[1]);
            points.push({x, y});

            x = Number(line[2]);
            y = Number(line[3]);
            points.push({x, y});
        }

        return points;
    },

    dataToPoints (data) {
        let points = [];
        let index = data.indexOf('L');
        let moveStr = data.substr(1, index - 1);
        let linesStr = data.substr(index, data.length - index);
        let x;
        let y;
        let line;
        let moves = moveStr.split(',');
        let lines = linesStr.split('L');

        lines = lines.splice(1, lines.length - 1);
        x = Number(moves[0]).toFixed(2);
        y = Number(moves[1]).toFixed(2);

        points.push({x, y});

        const length = lines.length;
        let i;

        for (i = 0; i < length; i++) {
            line = lines[i].split(',');
            x = Number(line[0]).toFixed(2);
            y = Number(line[1]).toFixed(2);

            points.push({x, y});
        }

        return points;
    },

    getFreehandSize (pathPoints) {
        let xMin = pathPoints[0].x;
        let xMax = pathPoints[0].x;
        let yMin = pathPoints[0].y;
        let yMax = pathPoints[0].y;
        let i;
        const length = pathPoints.length;

        for (i = 1; i < length; i++) {
            xMax = Math.max(xMax, pathPoints[i].x);
            xMin = Math.min(xMin, pathPoints[i].x);
            yMax = Math.max(yMax, pathPoints[i].y);
            yMin = Math.min(yMin, pathPoints[i].y);
        }

        return {
            x: xMin,
            y: yMin,
            width: Math.abs(xMax - xMin),
            height: Math.abs(yMax - yMin)
        };
    },

    converToLocalPathPoints (pathPoints, properties) {
        let i;
        const length = pathPoints.length;
        let newPathPoints = [];
        var xValue;
        var yValue;

        for (i = 1; i < length; i++) {
            xValue = pathPoints[i].x - properties.x;
            yValue = pathPoints[i].y - properties.y;

            newPathPoints.push({x: xValue.toFixed(2), y: yValue.toFixed(2)});
        }

        return newPathPoints;
    },

    getTextProperties (textArea) {
        let fontFamily = availableFonts.defaultFont;
        let fontAlign = 'left';
        let fontColor = '#000000';
        let fontSize = 12;
        let fontBold = false;
        let fontItalic = false;
        let fontUnderline = false;
        let htmlText = textArea.textContent;

        const p = textArea.firstChild;

        if (p) {
            fontAlign = String(p.getAttribute('ALIGN')).toLowerCase();

            const font = p.firstChild;

            if (font) {
                fontFamily = font.getAttribute('FACE');
                fontSize = parseFloat(font.getAttribute('SIZE'));
                fontColor = font.getAttribute('COLOR');

                const fontContent = font.toString();

                if (fontContent.indexOf('<U>') > 0)
                    fontUnderline = true;

                if (fontContent.indexOf('<B>') > 0)
                    fontBold = true;

                if (fontContent.indexOf('<I>') > 0)
                    fontItalic = true;
            }
        }

        fontFamily = this.getCorrectFont(fontFamily);

        return {
            fontFamily,
            fontAlign,
            fontColor,
            fontSize,
            fontBold,
            fontItalic,
            fontUnderline,
            htmlText
        };
    },

    getCorrectFont(font) {
        const fonts = availableFonts.getAvailableFonts();

        if (fonts.indexOf(font) < 0)
            return availableFonts.defaultFont;
        else
            return font;
    }
};

export default slideParserUtils;



/** WEBPACK FOOTER **
 ** ./src/parser/utils/SlideParserUtils.js
 **/